module.exports = __webpack_public_path__ + "static/img/e_bcg3.49bf48ad.png";